import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import type TemplateQuestion from 'modules/surveys/store/models/TemplateQuestion'

interface Props {
  templateQuestion: TemplateQuestion
}

const QuestionPosition = ({ templateQuestion }: Props) => {
  return (
    <Box
      height="s24"
      width="s24"
      background="viridian100"
      borderRadius={{
        all: 'rel333',
      }}
      justifyContent="center"
      alignItems="center"
    >
      <Text.Normal size="200" weight="semibold" color="viridian1200">
        {templateQuestion.attributes.position + 1}
      </Text.Normal>
    </Box>
  )
}

export default QuestionPosition
